<template lang="pug">

form.ui.form(v-on:submit.prevent="submit()")

    //- Navigation
    navigation

    //- Content
    .ui.top.attached.header Personendaten:
    person-form(
        ref="form"
        v-bind:companyModels='companies'
        v-model="mutable"
        v-on:cancel="cancel"
    )

    action-row.ui.bottom.secondary(v-on:cancel="cancel()")

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import ActionRow from '@/components/form/ActionRow'
    import PersonForm from '@/components/persons/CreateForm.vue'
    import Navigation from '@/components/addresses/Navigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        beforeRouteEnter(to, from, next) {
            // Unternehmen laden
            store.dispatch('companies/loadAll').then(next)
        },

        components: { ActionRow, Navigation, PersonForm },

        computed: {
            companies() {
                return store.getters['companies/all']
            },
            isInvalid() {
                return this.$refs.form.$v.$invalid
            }
        },

        data() {
            return {
                mutable: {}
            }
        },

        methods: {

            cancel() {
                this.$router.push({ name: 'persons' })
            },

            persist() {
                // Speichern
                this.$store.dispatch('persons/create', { model: this.mutable })

                    // Growl anzeigen
                    .then(() => this.$growl.success('Person wurde erstellt'))

                    // Weiterleiten
                    .then(() => this.$router.push({ name: 'persons' }))

                    // Fehler anzeigen
                    .catch(e => this.$growl.fatal('Person konnte nicht gespeichert werden', e))
            },

            submit() {
                this.$refs.form.validate().then(R.ifElse(R.equals(true), this.persist, this.$scrollToErrorAndFocus))
            }
        }

    }

</script>
